import Text from '@root/components/v2/ui-elements/Text';
import { VulnerabilityCounts } from '../VulnerabilityCounts';
import { TruncatedText } from './TableCardCells';

// Column sets for the dashboard's top-5 table cards. Rows arrive ranked server-side, so no column
// sorts. Each card is half the row wide, so every set carries only what ranks a row.

const countColumn = (field, headerName) => ({
  field,
  headerName,
  width: 90,
  sortable: false,
  renderCell: params => <Text font="medium">{(params.row[field] ?? 0).toLocaleString()}</Text>,
});

// The fix-impact APIs only count critical and high CVEs, so only those chips show.
const FIXABLE_SEVERITIES = ['critical', 'high'];

const fixableColumn = {
  field: 'fixable',
  headerName: 'Fixable CVEs',
  width: 130,
  sortable: false,
  renderCell: params => <VulnerabilityCounts vulnerabilities={params.row} severities={FIXABLE_SEVERITIES} />,
};

export const publicImageColumns = () => [
  {
    field: 'image',
    headerName: 'Image',
    flex: 1,
    minWidth: 130,
    sortable: false,
    renderCell: params => (
      <TruncatedText
        value={`${params.row.image}:${params.row.tag}`}
        tooltip={`${params.row.registry}/${params.row.image}:${params.row.tag}`}
      />
    ),
  },
  fixableColumn,
  countColumn('workloads', 'Workloads'),
];

export const packageColumns = () => [
  {
    field: 'package',
    headerName: 'Package',
    flex: 1,
    minWidth: 110,
    sortable: false,
    renderCell: params => (
      <TruncatedText
        value={`${params.row.package} ${params.row.version}`}
        tooltip={`${params.row.package} ${params.row.version} → ${params.row.fixed_version}`}
      />
    ),
  },
  {
    field: 'fixed_version',
    headerName: 'Fixed in',
    width: 80,
    sortable: false,
    renderCell: params => <TruncatedText value={params.row.fixed_version} />,
  },
  fixableColumn,
  countColumn('images', 'Images'),
];
